import * as React from 'react';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FileUpload from '@mui/icons-material/CloudUpload';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import { blue } from '@mui/material/colors';
import { connect } from 'react-redux'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import LayersIcon from '@mui/icons-material/Layers';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import { API_URL, S3_URL, ESHOW_URL } from '../../config.js'
import axios from 'axios';
import axiosInstance from '../../utils/axiosInstance.js'
import qs, { parse } from 'qs'
import { SVG, extend as SVGextend, Element as SVGElement } from '@svgdotjs/svg.js'
import { Canvg } from 'canvg';
import { setLoading,setBoothFileList } from '../../actions/main.js'
import LoadingOverlay from 'react-loading-overlay';
import ScaleLoader from 'react-spinners/ScaleLoader'
import { setBoothHistory } from '../../actions/booth_history.js'
import { fabric } from "fabric";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { v4 as uuidv4 } from 'uuid';
import {  px2unit, unit2Px } from '../../utils/CanvasTool.js'
import IconButton from '@mui/material/IconButton';
import ArrowUpwardOutlinedIcon from '@mui/icons-material/ArrowUpwardOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import {PaperComponent, getTokenCookie} from '../../utils/Common.js'
// duc
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';

import { setShowMapMenu } from '../../actions/main.js';
import MapMenu from './MapMenu';

import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { OrbitControls, MapControls } from '../../utils/OrbitControls'
import { Autocomplete } from '@mui/material';
import {AutoSizer, List as FixedSizeList } from 'react-virtualized';
import { Tooltip } from '@mui/material';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...(ownerState.active && {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <CloudUploadOutlinedIcon />,
    2: <LayersIcon />,
    3: <InsertPhotoOutlinedIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};
const steps = ['Select Background Source', 'Select Layer', 'Final image'];
var moveTimer = -1
var step2Canvas
var g_offsetX_Ft
var g_offsetY_Ft
var g_isDragging = false
let g_mapWidth = 860
let g_mapHeight = 500
var scene, camera, content, boothModel, font, meshes, g_initDistance
let renderer;
let controls;
let animateId;
let modelUrl;
let ground;

function OverviewModal(props) {
  const mainCanvasRef = useRef(null);
  const { onClose, onOk, onChange, open } = props;
  const [step, setStep] = React.useState(1);
  const [filetype, setFiletype] = React.useState("dwg");
  const [imgUrl, setImageUrl] = React.useState(null);
  const [dwgSvg, setDwgSvg] = React.useState(null);
  const [dwgFilteredSvg, setDwgFilteredSvg] = React.useState(null);
  const [mainLayers, setMainLayers] = React.useState([])
  const [imageWidth, setImageWidth] = React.useState(0)
  const [imageHeight, setImageHeight] = React.useState(0)
  const [imageWidth_Ft, setImageWidth_Ft] = React.useState(0)
  const [imageHeight_Ft, setImageHeight_Ft] = React.useState(0)
  const [factor, setFactor] = React.useState(1)
  const [prepareDwgimg, setPrepareDwgimg] = React.useState(false)
  const [preparePreviewDwgimg, setPreparePreviewDwgimg] = React.useState(false)  
  const [offsetX_Ft, setOffsetX_Ft] = React.useState(0)
  const [offsetY_Ft, setOffsetY_Ft] = React.useState(0)
  const [loadingFlag, setLoadingFlag] = React.useState(false)
  const [fileName, setFileName] = React.useState(false)

  const [openSnack, setOpenSnack] = React.useState(false);
  const [snackMsg, setSnackMsg] = React.useState('');
  const [delOverviewStatus, setDelOverviewStatus] = React.useState(false);

  const handleCloseSnack = ()=>{
    setOpenSnack(false);
  }

  const [overviewUrl, setOverviewUrl] = React.useState('');
  const [downloadUrl, setDownloadUrl] = React.useState('');  
  const [MapLinkList, setMapLinkList] = React.useState([]);
  const [MapLinkNameList, setMapLinkNameList] = React.useState([]);
  const [MapNameList, setMapNameList] = React.useState([]);

  const [boothMapList, setBoothMapist] = React.useState([]);

  const [tooltip, setTooltip] = React.useState({
          open: false,
          text: '',
          left: 0,
          top: 0,
      });

  React.useEffect(() => {
    if (overviewUrl!="") {
      loadModel(overviewUrl, fileName, 1);
    }
  }, [overviewUrl]);

  var mainCanvas = props.main.mainCanvas;

  var [overviewMap, setOverviewMap] = React.useState([]);  

  const [curFloor, setCurFloor] = React.useState([]);
  
  const openRef = useRef();
  var bgImgCanvas = props.main.bgImgCanvas

  const onSet = async ()=>{
    if(overviewUrl){
      props.setLoading(true);
      await saveSetup(overviewUrl);
      fetchmaplist();
    }
    onOk();
  }


  const fetchmaplist=async (KEY_ID=false)=>{ 
    var url = `${ESHOW_URL()}?method=getMaps&token=${getTokenCookie()}`

    axiosInstance.get(url).then(res=>{
      console.log(res.data)
      if(!res.data || (res.data && res.data.length == 0)){
          props.setLoading(false);
      }
      var tmp = [...res.data];
      var lastFile = null

      var active_booth_file = props.main.active_booth_file
      for(var i = 0; i <tmp.length; i++){
        let overview;
        var mapJS = tmp[i].MAPJS;
        try {
            mapJS = mapJS.replaceAll('\r\n', ' ')
            mapJS = JSON.parse(mapJS);
            if(mapJS?.overview){
                overview = i+1;
            }
            
            if(tmp[i]['KEY_ID'] == active_booth_file.KEY_ID){
                tmp[i] = {...tmp[i], ...mapJS, active:true};
            }
            else{
                tmp[i] = {...tmp[i], ...mapJS, active:false};
            }
        }
        catch(e){
            continue;
        }
      }

      // console.log("booth fetched")
      props.setBoothFileList(tmp)
      props.setLoading(false)
    }).catch(error => {
        props.setLoading(false)
    })           
    
  }

  useEffect(() => {
    
  }, [open])

  const init=()=> {
    //setMapLinkList([]);
    //setMapLinkNameList([]);
  }

  
  const reset=()=>{
    if(scene){    
        if(meshes && meshes.length > 0){
            for(var j = 0; j< meshes.length; j++){
                if(meshes[j].geometry)
                    meshes[j].geometry.dispose();
                if(meshes[j].material)
                    meshes[j].material.dispose();
                scene.remove(meshes[j])
            }
        }        
        meshes = [];
        for(var i in scene){
            delete scene[i]
        }
        scene = null;
    }
    if(camera){
        for(var i in camera){
            delete camera[i]
        }
        camera = null;
    }

    if(renderer){
        for(var i in renderer){
            delete renderer[i]
        }
        renderer = null;
    }
  }

  const saveSetup = async (modelUrl)=>{  
    var mapKEY_ID ;
    let curBoothFileList = props.main.boothFileList      
    for(var i = 0; i <curBoothFileList.length; i++){
      
      let mapJs = curBoothFileList[i]['MAPJS'];
      if(mapJs && mapJs != ''){
        try{
          mapJs = JSON.parse(mapJs);
        }
        catch(e){

        }
        if(mapJs.overview){
          mapKEY_ID = curBoothFileList[i]['KEY_ID'];
          break;
        } else {
          //boothMapList.push(curBoothFileList[i]);
        }
      }
    }
    var MAPJS = 
    {
      url: modelUrl,
      overview: 1,
      scale: factor,
      fileName:fileName,
      mapLink:MapLinkList,
    }
    if(!mapKEY_ID){
      mapKEY_ID = uuidv4();
    }
    var postData = [{
        DISPLAY_ORDER: 0,
        STATUS: "",
        TITLE: 'Overview',
        MAPJS: JSON.stringify(MAPJS),
        KEY_ID: mapKEY_ID,
        MIGRATE: ""
    }]
    var url = `${ESHOW_URL()}?method=putMaps&token=${getTokenCookie()}`
    
    const options = {
      headers: {
          'body': '[{"company:","test"}]', 
          'Content-Type': 'application/json'
        }
  }
    var response = await axiosInstance.post(url, JSON.stringify(postData), options)
    if(response.status == 200){
        var result = response.data
        setLoadingFlag(false)
    }  
    setLoadingFlag(false)
    return false;
  }

  useEffect(() => {
    if(open){
      setTimeout(()=>{        
        init();        

        let overviewMapJs = [];
        let curBoothFileList = props.main.boothFileList;
        let tmpMapNameList = [];
        for(var i = 0; i <curBoothFileList.length; i++){    
          let boothFile = curBoothFileList[i]
            let mapJs = boothFile?.['MAPJS'];
            
            if(mapJs && mapJs != ''){
                try{
                    mapJs = JSON.parse(mapJs);
                }
                catch(e){
                
                }
                if(mapJs?.overview){
                    overviewMapJs = mapJs;
                }
                else{
                  boothMapList.push(curBoothFileList[i]);
                  tmpMapNameList[curBoothFileList[i].KEY_ID] = curBoothFileList[i].TITLE;
                }
            }            
        }
          if(overviewMapJs){
            setFactor(overviewMapJs.scale?overviewMapJs.scale:1);
            // -duc-
            if(overviewMapJs.mapLink) {
              setMapLinkList(overviewMapJs.mapLink); //set linked map list
            }
            //loadMapNameList();
            setMapNameList(tmpMapNameList);
            setFileName(overviewMapJs.fileName);
            //loadModel(overviewMapJs.url, overviewMapJs.fileName, overviewMapJs.scale?overviewMapJs.scale:1);
            setOverviewUrl(overviewMapJs.url);
            //break;
          } 
      }, 500);
    }
  }, [open]);

  function getKeyByValue(list, targetValue) {
      if (!Array.isArray(list) || targetValue == null) {
          return null; // early exit if list is not valid or targetValue unset
      }
      const found = list.find(item => item.value.selectedId === targetValue);
      return found ? found.key : null;
    }

    window.setMapFloor = (floor) =>{
      setCurFloor(floor);
    };

    window.showSelectMapMenu = (pos, selectedId, name) => {
      props.setShowMapMenu({open:true, left: pos.x+5, top:pos.y+5, targetId:{selectedId,name}});
    }
    window.showSelectedMap = (pos, selectedId, name) => {

    }

    window.onSelectMap = (pos, obj) => {
      // Show map info as tooltip        
      let boothFileId = getKeyByValue(MapLinkList, obj.userData._id);
        if(boothFileId == null) {
            // alert("There is no linked map.");
           // setTooltip((prev) => ({ ...prev, open: false }));
            document.body.style.cursor = 'default';
            return;
        }
        // Show map info as tooltip
        // setTooltip({
        //   open: true,
        //   text: MapNameList[boothFileId],
        //   left: pos.x,
        //   top: pos.y - 10, // slightly above cursor
        // });       

        document.body.style.cursor = 'pointer';
    }
    // check if object is selectable
    window.isSelectable = (objId) => {
      let boothFileId = getKeyByValue(MapLinkList, objId);
      if(boothFileId == null) return false;
      return true;
  }

  // duc
  useEffect(() => {
  },[]);
  
  const loadModel=async (url, fileName, factor = 1)=>{
    setLoadingFlag(true);

    const targetDiv = document.getElementById('indoor3d');
    if (targetDiv) {
      while (targetDiv.firstChild) {
        targetDiv.removeChild(targetDiv.firstChild);
      }
    }
    
    const params = {
             mapDiv:"indoor3d",
             dim:"3d"
         }
    var overviewMap = window.IndoorMap(params);

    try{
      // if(overviewMap && overviewMap.length != 0){
      //   overviewMap.mall.freeAll();
      //   overviewMap.unload();        
      // }
      overviewMap.load(url, function(error){
          //model.setTheme(testTheme);
          if (error){
            //alert(error.message);
            setOpenSnack(true);
            setSnackMsg((error.message?(" "+error.message):""));
            setLoadingFlag(false);
            return;
          }

          overviewMap.showAreaNames(true).setSelectable(true);
          var ul = window.IndoorMap.getUI(overviewMap);
          if (targetDiv && ul != null) {
            targetDiv.appendChild(ul);
          }

          setFileName(fileName);

          setLoadingFlag(false);
      });
    } 
    catch(e){
      console.log("load error", e);
      setLoadingFlag(false);
    }
    
    //setLoadingFlag(false);
  }

  const onChangeFile = async (e)=>{
    //var convertRateX= Math.abs(props.main.mainCanvas.convertRateX)
    var file = openRef.current.files[0]
    var filename = file.name
    if(file){
      setFileName(filename)
      if(1){
        setFactor(1)
        var filename = file.name
        const reader = new FileReader();
        var data = file.slice(0, file.size);
        var filePath = `map_overview/${uuidv4()}`
        const formData = new FormData();
        const fileType = file.type || "application/octet-stream"; 
        const newFile = new File([file], file.name, {
            type: fileType,
            lastModified: file.lastModified
        });
        formData.append('file', newFile); 
        formData.append('filePath', filePath);
        var url = `${S3_URL()}uploadfile`
        setLoadingFlag(true)
        const headers = {headers: {'Content-Type': 'multipart/form-data'}};
        try{
          const response = await axiosInstance.post(url, formData, headers);
          if(response.status == 200){
            setOverviewUrl(`${S3_URL()}s3/${filePath}`);              
          }
          else
            setLoadingFlag(false)
        }
        catch(e){
          setLoadingFlag(false)
        }
      }
      openRef.current.value = null;
    }
  }

  const map_options = [{ label: 'Apple', id: 1 }, { label: 'Banana', id: 2 }];

  const changeMap =(event, newBoothFile)=> {
      if (newBoothFile) {
        setSelectedId(newBoothFile['KEY_ID']);
        console.log('Selected ID:', newBoothFile['KEY_ID']);
      } else {
        setSelectedId(null);
      }
  }

  const [selectedId, setSelectedId] = React.useState(null);

  function floorItemRenderer({
        key, // Unique key within array of rows
        index, // Index of row within collection
        isScrolling, // The List is currently being scrolled
        isVisible, // This row is visible within the List (eg it is not an overscanned row)
        style, // Style object to be applied to row (to position it)
        rowItems
    }) {
      
      var mapObject =rowItems?.points?.[index];
      if(mapObject){
        return (
          <ListItem 
            button 
            key={key} style={style}
          >            
            <ListItemText 
              primary={
                <Box display="flex">
                  <Box className="leftPrimaryTxt" style={{width:(props.main.showSetup?.MAP_LOCATION == 'show'?'55%':'80%'), fontSize:'14px'}}>
                    <div> {mapObject.name} </div>
                  </Box>
  
                  <Box pl={1} style={{width:'20%', fontSize:14.5, color: "#505050", textAlign:'center'}}>
                    <div> {mapObject.id} </div>
                  </Box>
                </Box>
              } 
            />
          </ListItem>
        );
      }
    }

    function mapItemRenderer({
        key, // Unique key within array of rows
        index, // Index of row within collection
        isScrolling, // The List is currently being scrolled
        isVisible, // This row is visible within the List (eg it is not an overscanned row)
        style, // Style object to be applied to row (to position it)
        rowItems
    }) {
      
      var mapObject =rowItems?.[index];
      if(mapObject){
        return (
          <ListItem 
            button 
            key={key} style={style}
          >            
            <ListItemText 
              primary={
                <Box display="flex">
                  <Box className="leftPrimaryTxt" style={{width:(props.main.showSetup?.MAP_LOCATION == 'show'?'35%':'50%'), fontSize:'14px'}}>
                    <div color='azure'> {mapObject.key} </div>
                  </Box>
  
                  <Box pl={1} style={{width:'50%', fontSize:14.5, color: "#505050", textAlign:'center'}}>
                    <div> {mapObject.value?.selectedId} </div>
                  </Box>
                </Box>
              } 
            />
          </ListItem>
        );
      }
    }

    const clearOverview = () => {
      const targetDiv = document.getElementById('indoor3d');
      if (targetDiv) {
        while (targetDiv.firstChild) {
          targetDiv.removeChild(targetDiv.firstChild);
        }
      }

      setOverviewUrl("");
      setFileName("");
      setCurFloor("");
    }

    const deleteOverview = async(modelUrl) => {
        if(!modelUrl.includes("https://")) {
          return;
        }
      
        var fileKey = modelUrl.replace('https://mapbeta.goeshow.com/proxy/s3/', '');

        var postData = {
          KEY_ID: fileKey ? fileKey : "",
          ACTIVE: 0
        }
        
        var url = `${S3_URL()}uploadfile`;
        
        axiosInstance.delete(url, {
          data: [postData],
          headers: {'Content-Type': 'application/json'}
        }).then(res=> {
          if(res.status) {
              setOpenSnack(true);
              setSnackMsg("deleted successfully");
              setDelOverviewStatus(true);
              

              //MapLinkList = [];
              //MapLinkNameList = [];

              clearOverview();
              
          } else {
              setOpenSnack(true);
              setSnackMsg("delete failed");
              setDelOverviewStatus(false);
          }
        });
    }

    const downloadOverview = async(modelUrl, filename) => {
      var fileKey = modelUrl.replace('https://mapbeta.goeshow.com/proxy/s3/', '');
      // var url = `${S3_URL()}download-url/${encodeURIComponent(fileKey || "")}`;

      var postData = {
        fileKey: fileKey ? fileKey : "",
      }
      
      var url = `${S3_URL()}download-url`;


     axios.post(url, {data: [postData] }).then(async(res) =>{
      if(res.data.status){
        const signedUrl = res.data.url;
        setDownloadUrl(res.data.url);

        try{
          const response = await fetch(signedUrl);

          // Make sure the response is OK
          if (!response.ok) {
            throw new Error('Network response was not OK');
          }

          const blob = await response.blob();

           // Create a temporary link element
          const tmpDownloadUrl = window.URL.createObjectURL(blob);
          
          const link = document.createElement('a');
          link.href = tmpDownloadUrl;
          link.download = filename;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          // link.remove();

          // Revoke the object URL to free memory
          window.URL.revokeObjectURL(tmpDownloadUrl);

        } catch (error){
          console.error("Download Failed:", error);
        }
      }
    }).catch(err=> {
        console.error('Error fetching S3 URL');
    });
  };
    
  // -duc-

  React.useEffect(() => {
    if(MapLinkList.length>0){
      loadMapNameList();
    }
  }, [MapLinkList]);

  function getValueByKey(list, targetKey) {
    const found = list.find(item => item.key === targetKey);
    return found ? found.value : null;
  }

  function setValueByKey(list, targetKey, newValue) {
    let index = -1;
    if(list.length !=0 ) index = list.findIndex(item => item.key === targetKey);
    if (index !== -1) {
      list[index].value = newValue;
    } else {
      // Optionally add new if key not found
      list.push({ key: targetKey, value: newValue });
    }
  }

  const handleClickMapLink = (target_info, map_id) =>{
    setValueByKey(MapLinkList, map_id, target_info);
    loadMapNameList();
  }

  const loadMapNameList = () =>{
    for(var i = 0; i< boothMapList.length; i++){
      let key_id = boothMapList[i].KEY_ID;

      let target_info = getValueByKey(MapLinkList, key_id);
      setValueByKey(MapLinkNameList, boothMapList[i].TITLE, target_info);
    }
  }
    

  return (
    <Dialog
      id="background-modal"
      fullWidth={true}
      maxWidth={"lg"}      
      PaperComponent={PaperComponent}
      PaperProps={{drag_id:'background-dialog-title'}}
      aria-labelledby="background-dialog-title"
      open={open}>
      <DialogTitle id='background-dialog-title' style={{display:'flex', alignItems:'center'}}><InsertPhotoOutlinedIcon style={{marginRight: 10}}/>Overview</DialogTitle>
      <DialogContent sx={{ overflow: 'hidden' }}>
        <Box sx={{ overflow: "hidden", height: "100%" }}>
            <Box mt={4}>
              <Grid
                container
                spacing={2}
                rowSpacing = {2}
              >
                <Grid item md={12}>
                  <div>
                    <FormControl>
                      <div>
                        <Button variant="contained" onClick={()=>{openRef.current.click()}} color="primary" endIcon = {<FileUpload/>}>
                          Upload
                        </Button>
                        <input type="file" ref={openRef} style={{display:"none"}} onChange={(e)=>onChangeFile(e)}  accept='.json'/>                        
                      </div>
                    </FormControl>
                    {overviewUrl &&
                    <FormControl sx={{marginLeft:'10px'}}>
                      <a style={{ textDecoration: 'none' }}>
                        <Button variant="contained" color="primary" onClick={()=>{downloadOverview(overviewUrl, fileName)}} endIcon = {<DownloadOutlinedIcon/>}>
                        Download
                        </Button>                      
                      </a>
                    </FormControl>
                    }             
                    {overviewUrl &&
                    <FormControl sx={{marginLeft:'10px'}}>
                      <Button variant="contained" onClick={()=>{deleteOverview(overviewUrl); }} color="primary" endIcon = {<DeleteForeverOutlinedIcon/>}>
                        Delete
                      </Button>
                      
                    </FormControl>}
                  </div>                  
                  {
                    fileName&& 
                      <Box mb={1} style={{fontWeight:'15px'}}>
                        {fileName}
                      </Box>
                  }
                </Grid>
                  {/* <Grid item md={12}>
                    <div> {overviewUrl} </div>
                  </Grid> */}
              </Grid>
            </Box>
            <Box mt={4} sx={{ overflow: "hidden", height: "100%" }}>
              <Grid
                container
                spacing={1}
                rowSpacing = {1}
                sx={{ overflow: "hidden" }}
              >
                <Grid item md={12}>
                  <Grid
                      container
                      spacing={2}
                      rowSpacing = {4}
                      sx={{ overflow: "hidden" }}
                  >
                    <Grid item md={9}>
                      {/* duc */}
                      <div id="indoor3d" ref={mainCanvasRef} style={{width:'100%', height: '480px', top:'0', left: '0', position:"relative"}}></div>
                      
                    </Grid>              
                    <Grid item md={3}>
                      {/* <Box pl={2} style={{borderLeft:'1px solid rgb(237 237 237)', height: 420}}>
                        <Box mb={3} style={{ height: '100%' }}>
                          {curFloor && curFloor.points?.length>0?(
                              <FixedSizeList
                                  width={260} 
                                  height={420}
                                  rowCount={curFloor.points.length}
                                  rowHeight={({ index }) => {
                                    // calculate height based on the row's content or data
                                    const item = curFloor.points[index];
                                    if (item.DATE!=undefined && item.DATE!="" ) return 50;
                                    else return 30; // default height
                                  }}
                                  rowRenderer={(param)=>floorItemRenderer({...param,rowItems: curFloor})}
                                />
                            ):(
                              <Box style={{textAlign:'center'}}>
                                <p>No Object Found.</p>
                              </Box>)}
                        </Box>                       
                      </Box> */}

                      <Box pl={2} style={{borderLeft:'1px solid rgb(237 237 237)', height: 420}}>
                        <Box mb={3} style={{backgroundColor:"#4E7090", height:'20px', padding:"16px", color: "white", marginBottom:"1px"}}>
                          <div style={{width:"60%", float:"left"}}> MapName </div>
                          <div style={{width:"40%", float:"left"}}> Linked </div>
                        </Box>
                        <Box mb={3} style={{ height: '100%', border: '1px solid #ddd' }}>
                          {MapLinkNameList && MapLinkNameList.length>0?(
                              <FixedSizeList
                                  width={260} 
                                  height={420}
                                  rowCount={MapLinkNameList.length}
                                  rowHeight={80}                                  
                                  rowRenderer={(param)=>mapItemRenderer({...param,rowItems: MapLinkNameList})}
                                />
                            ):(
                              <Box style={{textAlign:'center'}}>
                                <p>No Object Found.</p>
                              </Box>)}
                        </Box>                       
                      </Box>

                    </Grid>

                  </Grid>
                </Grid>
                
              </Grid>
            </Box>           
        </Box>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={()=>onSet()}>
          <b>Set</b>
        </Button>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
            
            <Snackbar
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
                }}
                open={openSnack}
                autoHideDuration={6000}
                onClose={handleCloseSnack}
                message={snackMsg}
                action={
                <React.Fragment>
                    <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnack}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </React.Fragment>
                }
            />

      <LoadingOverlay
        active={loadingFlag}
        styles={{
          // spinner: (base) => ({
          // ...base,
          // width: '50px',
          // '& svg circle': {
          //     stroke: '#1976d2'
          // }
          // }),
          overlay: (base) => ({
          ...base,
          fontSize:'18px',
          color: 'rgb(5, 37, 51)',
          // background: 'rgb(229 229 229 / 92%)',
          background: 'transparent',
          position:'fixed',
          zIndex:1000000000
          })
        }}
        spinner = {<ScaleLoader color={props.ui?.customStyles?.['spinner-color']?props.ui?.customStyles['spinner-color']:'#1976d2'} radius={2.5} margin={2.5} height={40} width={5}/>}
        >
      </LoadingOverlay> 
      <MapMenu onSetMapLink = {handleClickMapLink}></MapMenu>

      {/* <div>
            <Tooltip
              open={tooltip.open}
              title={tooltip.text}
              placement="top"
              PopperProps={{
                  disablePortal: true,
                  modifiers: [
                      {
                          name: 'offset',
                          options: {
                              offset: [0, 0],
                          },
                      },
                  ],
              }}
              componentsProps={{
                  tooltip: {
                      sx: {
                          fontSize: '16px', // Change font size here
                          backgroundColor: 'rgba(0, 0, 0, 0.87)',
                          padding: '8px 12px',
                      },
                  },
              }}
          >
              <div
              style={{
                  position: 'absolute',
                  left: tooltip.left,
                  top: tooltip.top,
                  width: '10px',
                  height: '10px',
                  backgroundColor: 'transparent', // or semi-visible for debug
              }}
              />
          </Tooltip>
      </div> */}
    </Dialog>
  );
}

const mapStateToProps = (state) => {
    return {
      main: state.main,
    };
  };
  
const mapDispatchProps = (dispatch) => {
  return {   
    setLoading:  data=>dispatch(setLoading(data)),
    setBoothHistory: data=>dispatch(setBoothHistory(data)),
    setBoothFileList:  data=>dispatch(setBoothFileList(data)),
    setShowMapMenu: data=>dispatch(setShowMapMenu(data)),
  };
};
  
export default connect(mapStateToProps, mapDispatchProps)(OverviewModal);